import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';
import { CrewQuestionnaireKind, useCrewQuestionnaireKind } from './useData';

const Form: React.FC = () => <GenericFormPage<CrewQuestionnaireKind> useData={useCrewQuestionnaireKind} config={{ ...moduleConfig, getInitialFormData, mapItemToFormData }} />;
export default Form;
